/* eslint-disable import/prefer-default-export */
import { getPartialPath } from '../../../utils/urlTools';

export const mapPagination = (valuesRequest) => ({
  currentPage: valuesRequest.current_page,
  firstPageUrl: getPartialPath(valuesRequest.first_page_url),
  lastPage: valuesRequest.last_page,
  lastPageUrl: getPartialPath(valuesRequest.last_page_url),
  nextPageUrl: valuesRequest.next_page_url === null
    ? null : getPartialPath(valuesRequest.next_page_url),
  path: getPartialPath(valuesRequest.path),
  perPage: valuesRequest.per_page,
  prevPageUrl: valuesRequest.prev_page_url === null
    ? null : getPartialPath(valuesRequest.prev_page_url),
  from: valuesRequest.from === null ? 0 : valuesRequest.from,
  to: valuesRequest.to === null ? 0 : valuesRequest.to,
  total: valuesRequest.total,
  data: valuesRequest.data,
  usersNavigation:valuesRequest.usersNavigation,
  operatingSystem:valuesRequest.operatingSystem?valuesRequest.operatingSystem:null
});
